import { Box } from '@mui/material';

import { TAGBrand } from '@/types';

import { wrapper, colorBlock } from './TAGDivider.styles';

const TAGDivider = () => {
	const brands = [TAGBrand.AspenDental, TAGBrand.ClearChoice, TAGBrand.Chapter, TAGBrand.WellNow, TAGBrand.Lovet];

	const getBrandColor = (brand: TAGBrand): string => {
		// Fallback to hardcoded values if needed
		switch (brand) {
			case TAGBrand.AspenDental:
				return '#184EB1';
			case TAGBrand.ClearChoice:
				return '#F19A31';
			case TAGBrand.Chapter:
				return '#AD1670';
			case TAGBrand.WellNow:
				return '#CD0E2D';
			case TAGBrand.Lovet:
				return '#3D8132';
			default:
				return 'neutrals.transparent';
		}
	};

	return (
		<Box sx={wrapper} data-testid="section_tagdivider">
			{brands.map((brand) => (
				<Box key={brand} sx={colorBlock(getBrandColor(brand))} />
			))}
		</Box>
	);
};

export default TAGDivider;
